// Copyright (c) Docugami, Inc. All rights reserved.

import { Component, ComponentId } from "sdv/engine/Component";
import { Box, makeInvalidBox } from "store/shared_types";

export interface BoundsComponent extends Component {
    typeId: ComponentId.Bounds,
    bounds: Box[];
    boundingBox: Box;
    containerBoxes: Box[];
    collisionEnabled: boolean;
}

export const createDefaultBoundsComponent = (): BoundsComponent => ({
    typeId: ComponentId.Bounds,
    bounds: [],
    containerBoxes: [],
    boundingBox: makeInvalidBox(),
    collisionEnabled: false
});
